import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import RelativeLink from "app/pages/.shared/RelativeLink";
import { FormattedMessage } from "react-intl";
import "./FaqBreadcrumb.scss";

const FaqBreadcrumb = ({ faqCategories = [], faqArticleTitle, url }) => {
	const { categoryId, subCategoryId } = useParams();

	const category = categoryId && faqCategories.find(faqCategory => faqCategory.id === categoryId);
	const subCategory =
		subCategoryId &&
		category &&
		category.subCategories &&
		category.subCategories.find(subCategory => subCategory.id === subCategoryId);

	return (
		<div className="faq-breadcrumb">
			{category && (
				<div className="faq-breadcrumb__item">
					<RelativeLink
						to={{
							pathname: `${url}`,
						}}
					>
						<FormattedMessage id="faq.breadcrumb.home" />
					</RelativeLink>
				</div>
			)}
			{category && (
				<div className="faq-breadcrumb__item">
					<RelativeLink
						to={{
							pathname: `${url}/category/${category.id}`,
						}}
					>
						> {category.name}
					</RelativeLink>
				</div>
			)}
			{subCategory && (
				<div className="faq-breadcrumb__item">
					<RelativeLink
						to={{
							pathname: `${url}/category/${category.id}/subcategory/${
								subCategory.id
							}`,
						}}
					>
						> {subCategory.name}
					</RelativeLink>
				</div>
			)}
			{faqArticleTitle && <div className="faq-breadcrumb__item">> {faqArticleTitle}</div>}
		</div>
	);
};

FaqBreadcrumb.propTypes = {
	faqCategories: PropTypes.array,
	faqArticleTitle: PropTypes.string,
	url: PropTypes.string,
};

export default FaqBreadcrumb;
